'use strict';

var sharedReact = require('@flex-packages/shared-react');
var initialValue = require('./initialValue.cjs');

const EnvContext = sharedReact.createGlobalReferenceContext("env-context", {
  env: {
    buildtime: initialValue.buildtimeEnvInitialValue,
    runtime: initialValue.runtimeEnvInitialValue
  }
});

exports.EnvContext = EnvContext;
//# sourceMappingURL=EnvContext.cjs.map
